import { useCallback, useLayoutEffect, useState } from "react";
import { db } from "firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import { storeInfo, storeInfoConverter } from "types/firestoreTypes";
import sleep from "modules/sleep";
import DefaultTemplate from "components/templates/DefaultTemplate";
import useFloorMap from "./useFloorMap";
import map_4 from "./images/map_4.svg";

type Floor = 4 | 5 | 6;

const FloorMap = () => {
    const [shopList, setShopList] = useState<storeInfo[]>([]);
    const [showShopList, setShowShopList] = useState<storeInfo[]>([]);
    const [isFocus, setIsFocus] = useState(false);
    const [inputted, setInputted] = useState("");

    const params = new URL(window.location.href).searchParams;
    const nf = params.get("now_floor");
    const goal = params.get("goal");
    const goalFloor =
        params.get("goal_floor") && isFinite(Number(params.get("goal_floor")))
            ? Number(params.get("goal_floor"))
            : null;
    const initFloor = nf ? (Number(nf) as Floor) : 4;

    const shopSearch = useCallback(
        (inputted: string) => {
            const reg = new RegExp(inputted);
            setShowShopList(
                shopList.filter(
                    (v) =>
                        v.store_name.match(reg) ||
                        v.tag.some((t) => t.match(reg))
                )
            );
        },
        [shopList]
    );

    useLayoutEffect(() => {
        (async () => {
            setShopList(
                (
                    await getDocs(
                        collection(db, "store_info").withConverter(
                            storeInfoConverter
                        )
                    )
                ).docs
                    .map((v) => v.data())
                    .sort((a, b) => (a.store_name > b.store_name ? 1 : -1))
                    .sort((a, b) => a.floor - b.floor)
            );
        })();
    }, []);

    useLayoutEffect(() => {
        shopSearch("");
    }, [shopList, shopSearch]);

    const { canvasRef, imgRef, floorChange } = useFloorMap({
        initFloor: initFloor,
        dest: goal,
        destFloor: goalFloor,
    });

    return (
        <DefaultTemplate style={{ textAlign: "center" }}>
            <h2 style={{ marginBottom: 0 }}>Map</h2>
            <div id="search">
                <input
                    type="text"
                    name="search-bar"
                    id="search-bar"
                    placeholder="店名を入力して検索"
                    style={{ marginBottom: 0 }}
                    value={inputted}
                    onFocus={() => setIsFocus(true)}
                    onBlur={async () => {
                        await sleep(100);
                        setIsFocus(false);
                    }}
                    onChange={(e) => {
                        setInputted(e.target.value);
                        shopSearch(e.target.value);
                    }}
                />
                <div
                    id="search-result"
                    style={{
                        width: "100%",
                        position: "absolute",
                        /* border: solid 1px; */
                        borderBottom: "solid 1px",
                        backgroundColor: "#fff",
                        zIndex: 1,
                    }}
                >
                    {isFocus &&
                        showShopList.map((shop) => {
                            return (
                                <div key={shop.store_name}>
                                    <a
                                        href={`/map?goal=${shop.store_name}&goal_floor=${shop.floor}`}
                                    >
                                        {shop.store_name}
                                    </a>
                                </div>
                            );
                        })}
                </div>
            </div>
            <div style={{ position: "relative", width: "100%" }}>
                <img id="mapImage" src={map_4} alt="map_image" ref={imgRef} />
                <canvas
                    style={{
                        position: "absolute",
                        left: "calc((100% - 241px) / 2)",
                        top: 0,
                    }}
                    ref={canvasRef}
                ></canvas>
            </div>
            <div id="floor-change">
                {/* <!-- <button id="1" className="floor-select-area">1F</button>
                <button id="2" className="floor-select-area">2F</button>
                <button id="3" className="floor-select-area">3F</button> --> */}
                <button
                    id="4"
                    className="floor-select-area"
                    onClick={() => floorChange(4, true)}
                >
                    4F
                </button>
                <button
                    id="5"
                    className="floor-select-area"
                    onClick={() => floorChange(5, true)}
                >
                    5F
                </button>
                <button
                    id="6"
                    className="floor-select-area"
                    onClick={() => floorChange(6, true)}
                >
                    6F
                </button>
                {/* <!-- <button id="7" className="floor-select-area">7F</button>
                <button id="8" className="floor-select-area">8F</button> --> */}
            </div>
        </DefaultTemplate>
    );
};

export default FloorMap;
